import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import { Button, InputX, LayerBottom } from 'components'
import styles from './index.module.css'

const JoinConfirm = () => {

	const App = useApp()
	const [showLayer, setShowLayer] = useState(true)

	const openLayer = () => {
		setShowLayer(true)
	}

	const closeLayer = () => {
		setShowLayer(false)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding pt_0">
				<div className={styles["join-box"]}>
					<p>비밀번호 재설정을 위해서는 회원정보<br />절차가 필요해요.</p>
					<p className="mt_20">번거로우시겠지만, 정보를 입력 후<br />비밀번호를 재설정해주세요.</p>
				</div>
				<h3 className="mt_30">이름을 입력해주세요.</h3>

				<p className="guide-title mt_40">이름</p>
				<InputX type="text" placeholder="이름 입력" id="" className="mt_10" />
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big" onClick={openLayer}>다음</Button>
			</div>

			<ConfirmLayer show={showLayer} closeLayer={closeLayer} />
		</div>
	)
}

const ConfirmLayer = ({ show, closeLayer }) => {
	return (
		<LayerBottom show={show} closeButton={false} closeConfirm={closeLayer} outside={
			<div className="btn-group">
				<Button className="btn btn--big btn-layer btn--gray" onClick={() => closeLayer()}>로그아웃</Button>
				<Button className="btn btn--big btn-layer">로그인 연장</Button>
			</div>
		}>
			<div>
				<div className="flex-align_center flex-column">
					<i className="icon icon_password_time" style={{ width: "9.6rem", height: "9.2rem" }} />
					<span className={`${styles["time-count"]} text-red mt_5`}>35초</span>
				</div>
				<div className="layer-text mt_20">
					<p>장시간 활동이 없어 자동으로 로그아웃됩니다.<br />계속 이용하시려면 로그인을 연장해주세요.</p>
				</div>
			</div>
		</LayerBottom>
	)
}

export default JoinConfirm